<section>
    <div class="mainDiv">
        <div class="banner_content">
            <div class="banner_content_slider">
                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/frinch_bg.png" width="100%" class="mob_franchise"
                    alt="">
                <div id="carouselExampleControls" class="carousel slide">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/frea_banner.png"
                                class="d-block img-fluid slider_banner" alt="...">
                        </div>
                        <div class="carousel-item">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/frea_banner.png"
                                class="d-block img-fluid slider_banner" alt="...">
                        </div>
                        <div class="carousel-item">
                            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/banner/frea_banner.png"
                                class="d-block img-fluid slider_banner" alt="...">
                        </div>
                    </div>
                    <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button> -->
                </div>

                <div class="form_content">
                    <div class="row flex-column-reverse flex-lg-row">
                        <div class="col-md-6">


                            <div class="desk_res">
                                <div class="count_box">
                                    <div class="count">
                                        <div class="num_box">2000+</div>
                                        <div class="count_para">
                                            Centers
                                        </div>
                                    </div>
                                    <div class="count">
                                        <div class="num_box">750+</div>
                                        <div class="count_para">
                                            Cities
                                        </div>
                                    </div>
                                    <div class="count">
                                        <div class="num_box">20+</div>
                                        <div class="count_para">
                                            Years of legacy
                                        </div>
                                    </div>
                                    <div class="count">
                                        <div class="num_box">20+</div>
                                        <div class="count_para">
                                            Million student enguire now
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="count_box mob_res">
                                <div class="carousel_container_mob">
                                    <div class="carousel_mob">
                                        <div class="product-card">
                                            <div class="count">
                                                <div class="num_box">2000+</div>
                                                <div class="count_para">
                                                    Centers
                                                </div>
                                            </div>
                                        </div>
                                        <div class="product-card">
                                            <div class="count">
                                                <div class="num_box">750+</div>
                                                <div class="count_para">
                                                    Cities
                                                </div>
                                            </div>
                                        </div>
                                        <div class="product-card">
                                            <div class="count">
                                                <div class="num_box">20+</div>
                                                <div class="count_para">
                                                    Years of legacy
                                                </div>
                                            </div>
                                        </div>
                                        <div class="product-card">
                                            <div class="count">
                                                <div class="num_box">20+</div>
                                                <div class="count_para">
                                                    Million student enguire now
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6">
                            <form action="" [formGroup]="admissionForm">
                                <div class="form">
                                    <div class="form_title">Enquire Now</div>
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="First Name*"
                                            formControlName="fname"
                                            [ngClass]="{ 'is-invalid': submitted && f.fname.errors }">
                                        <div *ngIf="submitted && f.fname.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.fname.touched || submitted) && f.fname.errors?.required">
                                                First name is required
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Last Name*"
                                            formControlName="lname"
                                            [ngClass]="{ 'is-invalid': submitted && f.lname.errors }">
                                        <div *ngIf="submitted && f.lname.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.lname.touched || submitted) && f.lname.errors?.required">
                                                Last name is required
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Email*"
                                            formControlName="email"
                                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                            <span class="text-danger msg_txt"
                                                *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
                                                Email is required
                                            </span>
                                            <span class="text-danger msg_txt"
                                                *ngIf="f.email.touched && f.email.errors?.email">
                                                Enter a valid email address
                                            </span>
                                        </div>
                                    </div>
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Mobile*"
                                            (keyup)="getMobileNO();" formControlName="mobile"
                                            [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }">
                                        <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                            <span *ngIf="f.mobile.errors?.required">Mobile is required.</span>
                                            <span *ngIf="f.mobile.errors?.pattern">Please, Enter 10 digit Mobile.</span>
                                        </div>
                                        <div *ngIf="otpInput" class="validMsg">OTP sent successfully</div>
                                    </div>
                                    <div class="form-group mt-2" *ngIf="otpInput">
                                        <input type="text" class="form-control" placeholder="Enter otp*"
                                            (keyup)="verifyOTP();" formControlName="otp"
                                            [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
                                        <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
                                            <span *ngIf="f.otp.errors?.required">OTP is required.</span>
                                        </div>
                                        <div *ngIf="otp_ValidMsg" class="validMsg">otp verified successfully</div>
                                        <div *ngIf="otp_inValidMsg" class="inValidMsg">please enter valid otp</div>
                                    </div>
                                    <div class="form-group mt-2">
                                        <input type="text" class="form-control" placeholder="Pin Code*"
                                            formControlName="pinCode"
                                            [ngClass]="{ 'is-invalid': submitted && f.pinCode.errors }">
                                        <div *ngIf="submitted && f.pinCode.errors" class="invalid-feedback">
                                            <span *ngIf="f.pinCode.errors?.required">Pin code is required.</span>
                                            <span *ngIf="f.pinCode.errors?.pattern">Please, Enter 6 digit
                                                pincode.</span>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group mt-2">
                                                <select name="" id="" class="form-control" formControlName="state"
                                                    (change)="selectState($event)"
                                                    [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                                                    <option value="">State/District</option>
                                                    <option value="{{state.State_Name}}"
                                                        *ngFor="let state of stateList">
                                                        {{state.State_Name}}</option>
                                                </select>
                                                <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                                    <span class="text-danger msg_txt"
                                                        *ngIf="(f.state.touched || submitted) && f.state.errors?.required">
                                                        State/District is required
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mt-2">
                                                <select name="" id="" class="form-control" formControlName="city"
                                                    (change)="selectCity($event)"
                                                    [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
                                                    <option value="">City</option>
                                                    <option value="{{city.City_Name}}" *ngFor="let city of cityList">
                                                        {{city.City_Name}}</option>
                                                </select>
                                                <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                                                    <span class="text-danger msg_txt"
                                                        *ngIf="(f.city.touched || submitted) && f.city.errors?.required">
                                                        City is required
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="form-group mt-2">
                                        <div class="form-check">
                                            <input class="form-check-input" checked disabled type="checkbox" value=""
                                                id="flexCheckDefault">
                                            <label class="form-check-label" for="flexCheckDefault">
                                                I state that I am ready with a min investment of INR 15 - 16 Lacs* & a
                                                min
                                                space
                                                of 2000-3000 sqft, and have read, understood and accepted your Privacy
                                                Policy
                                                and the Terms
                                            </label>
                                        </div>
                                    </div>

                                    <div class="form-group mt-2 d-flex justify-content-center">
                                        <button class="submit_btn" (click)="validationForm();">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <h1 class="white_text">Franchise Opportunity</h1>
            <div class="banner_text">
                <h4 class="text-white text-left">Start your own Kidzee preschool today!</h4>
                <div class="sub_text">All you need is a 2000-3000* sq. feet space and an investment ₹ 15-16 lakhs*</div>
            </div>
            <div class="subMenu_content">
                <app-sub-menu></app-sub-menu>
            </div>
        </div>
        <div class="aboutUs_content">
            <app-about-us></app-about-us>
        </div>
        <div class="chain_content">
            <div class="chain_text">
                Easy steps to partner with India’s widely present preschool chain!
            </div>
            <div class="container">
                <div class="desk_res">
                    <div class="easy_steps">
                        <div class="count1"> 
                            <div class="num_box1"><span class="day">Day</span>1</div>
                            <div class="count_para1">
                                Enquire with us and fix a meeting for franchise business
                            </div>  
                        </div>
                        <div class="count1">   
                            <div class="num_box1"><span class="day">Day</span>2</div>
                            <div class="count_para1">
                                Finalise your Preschool and Daycare location
                            </div> 
                        </div>
                        <div class="count1"> 
                            <div class="num_box1"><span class="day">Day</span>22</div>
                            <div class="count_para1">
                                Sign up with Us
                            </div>   
                        </div>
                        <div class="count1">  
                            <div class="num_box1"><span class="day">Day</span>45</div>
                            <div class="count_para1">
                                Your Kidzee Preschool is operational
                            </div>  
                        </div>
                    </div>
                </div>

                <div class="count_box mob_res">
                    <div class="carousel_container_mob1">
                        <div class="carousel_mob">
                            <div class="product-card">
                                <div class="count1"> 
                                    <div class="num_box1"><span class="day">Day</span>1</div>
                                    <div class="count_para">
                                        Enquire with us and fix a meeting for franchise business
                                    </div>  
                                </div>
                            </div>
                            <div class="product-card">
                                <div class="count1">   
                                    <div class="num_box1"><span class="day">Day</span>2</div>
                                    <div class="count_para">
                                        Finalise your Preschool and Daycare location
                                    </div> 
                                </div>
                            </div>
                            <div class="product-card">
                                <div class="count1"> 
                                    <div class="num_box1"><span class="day">Day</span>22</div>
                                    <div class="count_para">
                                        Sign up with Us
                                    </div>   
                                </div>
                            </div>
                            <div class="product-card">
                                <div class="count1">  
                                    <div class="num_box1"><span class="day">Day</span>45</div>
                                    <div class="count_para">
                                        Your Kidzee Preschool is operational
                                    </div>  
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="faqs_content">
            <app-faqs></app-faqs>
        </div>

        <div class="faqs_content">
            <app-blogs></app-blogs>
        </div>
        <div class="testimonial_content">
            <app-testimonial></app-testimonial>
        </div>
    </div>
</section>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>